/**
 * account feature routes — owned by web-clubs-platform.
 * Add child routes here (this file and everything under features/account/ belong to the owner).
 * The pathless "accountFeature" route is registered once in src/app/router.tsx (frozen).
 */
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../../app/root-route';

export const accountFeature = createRoute({ getParentRoute: () => rootRoute, id: 'account' });

export const meRoute = createRoute({
  getParentRoute: () => accountFeature,
  path: '/me',
  component: lazyRouteComponent(() => import('./pages/MyRecordsPage'), 'MyRecordsPage'),
});

/** 나의 대회: personal tournaments, credits, member list (CLAUDE.md §15 #405–#416) */
export const myTournamentsRoute = createRoute({
  getParentRoute: () => accountFeature,
  path: '/me/tournaments',
  component: lazyRouteComponent(() => import('./pages/MyTournamentsPage'), 'MyTournamentsPage'),
});

/** single entry of "create my tournament": make the personal space, then the wizard */
export const createPersonalRoute = createRoute({
  getParentRoute: () => accountFeature,
  path: '/me/tournaments/new',
  component: lazyRouteComponent(() => import('./pages/CreatePersonalPage'), 'CreatePersonalPage'),
});

export const changePasswordRoute = createRoute({
  getParentRoute: () => accountFeature,
  path: '/me/password',
  component: lazyRouteComponent(() => import('./pages/ChangePasswordPage'), 'ChangePasswordPage'),
});

export const registerRoute = createRoute({
  getParentRoute: () => accountFeature,
  path: '/register',
  component: lazyRouteComponent(() => import('./pages/RegisterPage'), 'RegisterPage'),
});

/**
 * /privacy is a static server page (apps/web/public/privacy/). This route only catches the app
 * shell answering that navigation (an outdated service worker, the vite dev server) and reloads
 * the server page — see common/privacy-redirect.ts.
 */
export const privacyRoute = createRoute({
  getParentRoute: () => accountFeature,
  path: '/privacy',
  component: lazyRouteComponent(() => import('./pages/PrivacyRedirectPage'), 'PrivacyRedirectPage'),
});

export const accountRouteTree = accountFeature.addChildren([
  meRoute,
  myTournamentsRoute,
  createPersonalRoute,
  changePasswordRoute,
  registerRoute,
  privacyRoute,
]);
